export enum QueryType {
  Name = "Name",
  Email = "Email",
}
